/**
 * Local-date utilities for YYYY-MM-DD strings.
 *
 * The API returns local dates (e.g. "2026-07-25") as plain strings — not
 * timestamps.  We must parse and format them in the *local* timezone to
 * avoid UTC-shift bugs that lose a day for any negative offset (PST, EDT, …).
 */

/**
 * Parse a local YYYY-MM-DD string into a Date at local midnight.
 * Uses local components (never UTC) so the date never shifts.
 */
export function parseLocalDate(dateStr: string): Date {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/**
 * Format a Date as YYYY-MM-DD in the *local* timezone.
 * Avoids `toISOString()` which always produces UTC.
 */
export function formatLocalDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
